import { render, staticRenderFns } from "./CellRendererActions.vue?vue&type=template&id=0bef65a2&scoped=true"
import script from "./CellRendererActions.vue?vue&type=script&lang=js"
export * from "./CellRendererActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bef65a2",
  null
  
)

export default component.exports